import { GetServerSideProps } from 'next';
import { ThemeProvider } from 'styled-components';

import Footer from '@/components/footer/FooterWrapper';
import HeaderRefresh from '@/components/homepageRefresh/header/Header';
import Layout from '@/components/layout/LayoutWrapper';
import blogMessages from '@/components/subpages/data/mindfulness/blog';
import FAQSections from '@/components/subpages/data/mindfulness/faq.mdx';
import heroMessages from '@/components/subpages/data/mindfulness/hero';
import instructorVideoMessages from '@/components/subpages/data/mindfulness/instructorVideo';
import { reviews, messages as reviewsMessages } from '@/components/subpages/data/mindfulness/reviews';
import { sections, messages as toolsMessages } from '@/components/subpages/data/mindfulness/tools';
import unlockMessages from '@/components/subpages/data/mindfulness/unlock';
import { mindfulnessTheme } from '@/components/subpages/data/themes';
import SubpageLayout from '@/components/subpages/SubpageLayout';
import { InitRequest } from '@/hooks/store';
import { getInitialServerState } from '@/utils/pageGeneration/getServerSideProps';

const MindfulnessSubpage = () => {
	return (
		<Layout
			customSeo={{
				title: 'Mindfulness Meditation, Music and Guided Tools  - Calm',
				primaryDescription:
					'Learn how to meditate and embrace mindfulness. Join the millions leveraging our guided meditations, music, and daily mindfulness tools.',
			}}
			pageName="mindfulness"
		>
			<ThemeProvider theme={mindfulnessTheme}>
				<HeaderRefresh isOpaque />
				<SubpageLayout
					heroHeading={heroMessages.heading}
					heroBody={heroMessages.body}
					heroCta={heroMessages.cta}
					heroBgImage="/_n/images/subpages/mindfulness-hero.webp"
					mediaSectionType="instructor"
					mediaSectionHeading={instructorVideoMessages.heading}
					instructorVideoThumbnail="/_n/images/subpages/jeff-warren-video-thumbnail-2.webp"
					instructorVideoSrc="/_n/videos/jeff-instructor-preview.mp4"
					instructorVideoCaptionsSrc="/_n/videos/jeff-instructor-preview.vtt"
					unlockHeading={unlockMessages.heading}
					unlockBody={unlockMessages.body}
					unlockBgImage="/_n/images/subpages/mindfulness-collage.webp"
					plansBgImage="/_n/images/subpages/mindfulness-plans.webp"
					reviews={reviews}
					reviewsHeading={reviewsMessages.reviewsHeading}
					blogHeading={blogMessages.heading}
					blogCategory="mindfulness"
					toolsSections={sections}
					toolsHeading={toolsMessages.heading}
					FaqSections={FAQSections}
				/>
			</ThemeProvider>
			<Footer />
		</Layout>
	);
};

export const getServerSideProps: GetServerSideProps = async context => {
	const initialState = await getInitialServerState(
		context,
		[InitRequest.DEVICE, InitRequest.USER, InitRequest.PRICES],
		undefined,
		undefined,
		true,
	);

	return {
		props: {
			initialState,
		},
	};
};

export default MindfulnessSubpage;
